import {
  HEX,
  SCALING,
  Targeting
} from "../../../src";
const goldMagebolt = {
  slug: "goldMagebolt",
  name: "Gold Magebolt",
  abilityIcon: "magebolt_gold",
  description: "Hurls a magical bolt that deals gold damage",
  costs: [{ stat: "mana", value: 5 }],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  // Slower than arrows
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.RADIANT_DAMAGE
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "gold"]
};
const redMagebolt = {
  slug: "redMagebolt",
  name: "Red Magebolt",
  abilityIcon: "magebolt_red",
  description: "Hurls a magical bolt that deals red damage",
  costs: [{ stat: "mana", value: 5 }],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  // Slower than arrows
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.FIRE
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "red"]
};
const greenMagebolt = {
  slug: "greenMagebolt",
  name: "Green Magebolt",
  abilityIcon: "magebolt_green",
  description: "Hurls a magical bolt that deals green damage",
  costs: [{ stat: "mana", value: 5 }],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  // Slower than arrows
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.NATURE_DAMAGE
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "green"]
};
const blueMagebolt = {
  slug: "blueMagebolt",
  name: "Blue Magebolt",
  abilityIcon: "magebolt_blue",
  description: "Hurls a magical bolt that deals blue damage",
  costs: [{ stat: "mana", value: 5 }],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  // Slower than arrows
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.ARCANE
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "blue"]
};
const blackMagebolt = {
  slug: "blackMagebolt",
  name: "Black Magebolt",
  abilityIcon: "magebolt_black",
  description: "Hurls a magical bolt that deals black damage",
  costs: [{ stat: "mana", value: 5 }],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  // Slower than arrows
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.SHADOW
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["spell", "ranged", "black"]
};
export {
  blackMagebolt,
  blueMagebolt,
  goldMagebolt,
  greenMagebolt,
  redMagebolt
};
//# sourceMappingURL=data:application/json;base64,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
